import React, { useState } from 'react'
import { Alert } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const Confirm = (props) => {
  const [show, setShow] = useState(true);

  

  const deleteFinancialYear = () => {
    props.deleteFinancialYear();
  }


  const deleteFile = () => {
    props.deleteFile();
  }
  
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >

      <Alert show={show} variant="danger" className='mb-0'>
        <Alert.Heading>{props.title}</Alert.Heading>
        <p>
          {props.message}
        </p>
        <hr />
        <div className="d-flex justify-content-end">
          
          {props.table === "financialYear" &&
            <Button onClick={props.deleteFinancialYearRec} variant="danger" className='mx-2'>
              Yes
            </Button>
          }

          {props.table === "branch" &&
            <Button onClick={props.deleteBranchRec} variant="danger" className='mx-2'>
              Yes
            </Button>
          }

          {props.table === "item" &&
            <Button onClick={props.deleteItemRec} variant="danger" className='mx-2'>
              Yes
            </Button>
          }

          {props.table === "supplier" &&
            <Button onClick={props.isdelete} variant="danger" className='mx-2'>
              Yes
            </Button>
          }

          {props.table === "client" &&
            <Button onClick={props.isdelete} variant="danger" className='mx-2'>
              Yes
            </Button>
          }

          {props.table === "transporter" &&
            <Button onClick={props.isdelete} variant="danger" className='mx-2'>
              Yes
            </Button>
          }

          {props.table === "Driver" &&
            <Button onClick={props.isdelete} variant="danger" className='mx-2'>
              Yes
            </Button>
          }

          {props.table === "Vehicle" &&
            <Button onClick={props.isdelete} variant="danger" className='mx-2'>
              Yes
            </Button>
          }

           {props.table === "purchase_line_items" &&
            <Button onClick={props.deleteRecord} variant="danger" className='mx-2'>
              Yes
            </Button>
          }
          
          
          {props.table === "file" &&
            <Button onClick={props.deleteFile} variant="danger" className='mx-2'>
             Yes
            </Button>
          }
          
          <Button onClick={props.onHide} variant="light" className="text-">
            No
          </Button>
        </div>
      </Alert>
    </Modal>
  )
}

export default Confirm